// import {Highlight, themes, Prism } from "prism-react-renderer"
import React, { useEffect } from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.min.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.min.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/toolbar/prism-toolbar';
import 'prismjs/plugins/toolbar/prism-toolbar.min.css';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-rust';
import 'prismjs/components/prism-go';
import { Tabs } from '@/components/v2/global';
import './code.css';

interface CodeProps {
  codeString: string;
  title?: string;
  language: string | null | undefined;
  tabs?: string[];
  onTabChange?: (tab: string) => void;
  selectedTab?: string;
  removeNativeStyles?: boolean;
}

const getLanguage = (language: string | null | undefined) => {
  if (!language) return 'bash';
  if (language.toLowerCase().includes('curl')) {
    return 'json';
  }
  return language;
}

const Code = ({
  codeString,
  title,
  language,
  tabs,
  onTabChange,
  selectedTab,
  removeNativeStyles
}: CodeProps) => {
  const currentLang = getLanguage(language) || 'bash';

  useEffect(() => {
    Prism.highlightAll();
  }, [codeString]);

  return (
    <div>
      {tabs && (
        <Tabs
          tabs={tabs}
          selectedTab={selectedTab || tabs[0]}
          onTabChange={onTabChange || (() => { })}
        />
      )}
      <pre className={`text-sm ${tabs ? 'with-tabs' : ''} ${tabs ? 'rounded-b-md' : 'rounded-md'} ${removeNativeStyles ? 'remove-native-styles' : ''}`}>
        <code
          data-prismjs-copy="Copy"
          data-prismjs-copy-error="OOPS"
          data-prismjs-copy-success="Copied"
          data-prismjs-copy-timeout="1000"
          className={`language-${currentLang} language-py text-sm`}
        >
          {codeString}
        </code>
      </pre>
      {title && (
        <p className="text-center">
          <span className="text-sm font-normal">{title}</span>
        </p>
      )}
    </div>
  );
};

export default Code;
